import CardDesignerCardElementFrame from './CardDesignerCardElementFrame';

export default CardDesignerCardElementFrame;
